import { authHeader, handleResponse } from '../helpers';
export const CartonReturnService = {
    fetchReverseData,
    SaveReversePoint  
};

function fetchReverseData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}Reverse/GetReverse`, requestOptions)
        .then(handleResponse);
}

function SaveReversePoint(data){
    const requestOptions={
        method:'Post',
        headers:authHeader(),
        body:JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}Reverse/ReversePoint`,requestOptions)
    .then(handleResponse);
}